// extracted by mini-css-extract-plugin
module.exports = {"apple":"ApplePayButton_apple__ud1lU","loading":"ApplePayButton_loading__7UYjV","shine":"ApplePayButton_shine__vh_Sl"};